import * as mt from './mutation-types';
import { Owner, AdmittedStatus } from './types'
import { Owner as OwnerDTO, OwnerAdmittedCount, OwnerFilter } from '@/api/owner/types';
import { PaginatedResponseContent } from '@/api/types'; 
import { AdmittedFilter } from "@/constants/owner";

// status:
// no-owner - no owner present; initial status
// fetching:by-key - fetching owner by key
// fetch:by-key - found owner after fetch by key
// fetch:no-owner - owner does not exists in base
// submiting:owner - submiting an owner
// fetch:owner - found owner
// error:create - error while trying to create a new owner
// error:update - error while trying to update an owner
interface OwnerPayload {
  owner: OwnerDTO,
  owners: PaginatedResponseContent<OwnerDTO>,
  admittedCount: OwnerAdmittedCount
}

export default {
  [mt.CLEAR_OWNER] (state: Owner) {
    state.ownerContext = null;
    state.status = 'no-owner';
    state.errorContext = null;
  },
  [mt.FETCHING_OWNER_BY_KEY] (state: Owner) {
    state.status = 'fetching:by-key';
  },
  [mt.FETCH_BY_KEY_SUCCESS] (state: Owner, { owner }: OwnerPayload) {
    state.ownerContext = owner;
    state.status = 'fetch:by-key';
  },
  [mt.FETCHING_OWNER_BY_ID] (state: Owner) {
    state.status = 'fetching:by-id';
  },
  [mt.FETCH_BY_ID_SUCCESS] (state: Owner, { owner }: OwnerPayload) {
    state.ownerContext = owner;
    state.status = 'fetch:by-id';
  },
  [mt.FETCH_FAILURE] (state: Owner) {
    state.ownerContext = null;
    state.status = 'fetch:no-owner';
  },
  [mt.SUBMITING_OWNER](state: Owner) {
    state.status = 'submiting:owner';
  },
  [mt.FETCH_OWNER_SUCCESS](state: Owner, { owner }: OwnerPayload) {
    state.ownerContext = owner;
    state.status = 'fetch:owner';
  },
  [mt.CREATE_OWNER_FAILURE](state: Owner, { owner }: OwnerPayload) {
    state.errorContext = owner;
    state.status = 'error:create';
  },
  [mt.UPDATE_OWNER_FAILURE](state: Owner, { owner }: OwnerPayload) {
    state.errorContext = owner;
    state.status = 'error:update';
  },
  [mt.FETCHING_OWNERS_BY_FILTER] (state: Owner) {
    state.ownersStatus = 'fetching:by-filter';
  },
  [mt.FETCHING_OWNERS_BY_FILTER_SUCCESS] (state: Owner, { owners }: OwnerPayload) {
    state.ownersContext = owners;
    state.ownersStatus = 'fetch:by-filter';
  },
  [mt.FETCH_OWNERS_FAILURE] (state: Owner) {
    state.ownersContext = null;
    state.ownersStatus = 'fetch:no-owners';
  },
  [mt.FETCHING_ADMITTED_COUNT] (state: Owner) {
    state.ownerAdmittedStatus = AdmittedStatus.FETCHING;
  },
  [mt.FETCH_ADMITTED_COUNT_SUCCESS] (state: Owner, { admittedCount }: OwnerPayload) {
    state.ownerAdmittedContext = admittedCount;
    state.ownerAdmittedStatus = AdmittedStatus.FETCH;
  },
  [mt.FETCH_ADMITTED_COUNT_FAILED] (state: Owner) {
    state.ownerAdmittedContext = null;
    state.ownerAdmittedStatus = AdmittedStatus.FETCH_FAILED;
  },
  [mt.DELETE_OWNER_FAILURE](state: Owner, { owner }: OwnerPayload) {
    state.errorContext = owner;
    state.status = 'error:delete';
  },
  [mt.CHANGE_FILTER_VALUE] (state: Owner, filter: OwnerFilter) {
    state.ownersFilter = filter;
  },
  [mt.PERSIST_FILTER] (state: Owner) {
    try {
      localStorage.setItem('_owners_filter', JSON.stringify(state.ownersFilter));
    } catch {}
  },
  [mt.CLEAR_FILTER] (state: Owner) {
    state.ownersFilter = { onlyUserOwners: false, admitted: AdmittedFilter.ALL } as OwnerFilter;
  },
  
};
